export const VERIFY_EMAIL = "VERIFY_EMAIL"
export const VERIFY_EMAIL_SUCCESSFUL = "VERIFY_EMAIL_SUCCESSFUL"
export const VERIFY_EMAIL_FAILED = "VERIFY_EMAIL_FAILED"